export default __webpack_public_path__ + "static/media/tounge.0c5ee57a.svg";